const useListColumns = () => {
  return [
    {
      Header: "#",
      accessor: "order",
      disableSortBy: true,
      disableGlobalFilter: true,
    },
    {
      Header: "Name",
      accessor: "name",
    },
    {
      Header: "Last name",
      accessor: "lastname",
      disableGlobalFilter: true,
    },
    {
      Header: "Username",
      accessor: "username",
      disableGlobalFilter: true,
    },
    {
      Header: "Mail",
      accessor: "mail",
      disableGlobalFilter: true,
    },
    {
      Header: "Created At",
      accessor: "createDate",
      disableGlobalFilter: true,
      sortType: (rowA: any, rowB: any) => rowA.original._createDateTs - rowB.original._createDateTs,
    },
    {
      Header: "State",
      accessor: "state",
      disableGlobalFilter: true,
    },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      disableGlobalFilter: true,
    },
  ];
};

export default useListColumns;
